// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file sidecar/v1/printer_local_api.proto (package sidecar.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sidecar/v1/printer_local_api.proto.
 */
export const file_sidecar_v1_printer_local_api: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message sidecar.v1.PrinterInfo
 */
export type PrinterInfo = Message<"sidecar.v1.PrinterInfo"> & {
  /**
   * @generated from field: string printer_id = 1;
   */
  printerId: string;

  /**
   * @generated from field: string unique_id = 2;
   */
  uniqueId: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string driver_type = 4;
   */
  driverType: string;

  /**
   * @generated from field: string manufacturer = 5;
   */
  manufacturer: string;

  /**
   * @generated from field: string model = 6;
   */
  model: string;

  /**
   * @generated from field: bool online = 7;
   */
  online: boolean;
};

/**
 * Describes the message sidecar.v1.PrinterInfo.
 * Use `create(PrinterInfoSchema)` to create a new message.
 */
export const PrinterInfoSchema: GenMessage<PrinterInfo> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 0);

/**
 * @generated from message sidecar.v1.ListPrintersRequest
 */
export type ListPrintersRequest = Message<"sidecar.v1.ListPrintersRequest"> & {
};

/**
 * Describes the message sidecar.v1.ListPrintersRequest.
 * Use `create(ListPrintersRequestSchema)` to create a new message.
 */
export const ListPrintersRequestSchema: GenMessage<ListPrintersRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 1);

/**
 * @generated from message sidecar.v1.ListPrintersResponse
 */
export type ListPrintersResponse = Message<"sidecar.v1.ListPrintersResponse"> & {
  /**
   * @generated from field: repeated sidecar.v1.PrinterInfo printers = 1;
   */
  printers: PrinterInfo[];
};

/**
 * Describes the message sidecar.v1.ListPrintersResponse.
 * Use `create(ListPrintersResponseSchema)` to create a new message.
 */
export const ListPrintersResponseSchema: GenMessage<ListPrintersResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 2);

/**
 * @generated from message sidecar.v1.GetPrinterInfoRequest
 */
export type GetPrinterInfoRequest = Message<"sidecar.v1.GetPrinterInfoRequest"> & {
  /**
   * @generated from field: string printer_id = 1;
   */
  printerId: string;
};

/**
 * Describes the message sidecar.v1.GetPrinterInfoRequest.
 * Use `create(GetPrinterInfoRequestSchema)` to create a new message.
 */
export const GetPrinterInfoRequestSchema: GenMessage<GetPrinterInfoRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 3);

/**
 * @generated from message sidecar.v1.GetPrinterInfoResponse
 */
export type GetPrinterInfoResponse = Message<"sidecar.v1.GetPrinterInfoResponse"> & {
  /**
   * @generated from field: sidecar.v1.PrinterInfo printer = 1;
   */
  printer?: PrinterInfo;
};

/**
 * Describes the message sidecar.v1.GetPrinterInfoResponse.
 * Use `create(GetPrinterInfoResponseSchema)` to create a new message.
 */
export const GetPrinterInfoResponseSchema: GenMessage<GetPrinterInfoResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 4);

/**
 * @generated from message sidecar.v1.PrintJobInfo
 */
export type PrintJobInfo = Message<"sidecar.v1.PrintJobInfo"> & {
  /**
   * @generated from field: uint32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string document_name = 2;
   */
  documentName: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: int64 submitted_at = 4;
   */
  submittedAt: bigint;

  /**
   * @generated from field: uint32 pages = 5;
   */
  pages: number;

  /**
   * @generated from field: uint32 size = 6;
   */
  size: number;
};

/**
 * Describes the message sidecar.v1.PrintJobInfo.
 * Use `create(PrintJobInfoSchema)` to create a new message.
 */
export const PrintJobInfoSchema: GenMessage<PrintJobInfo> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 5);

/**
 * @generated from message sidecar.v1.GetPrintQueueRequest
 */
export type GetPrintQueueRequest = Message<"sidecar.v1.GetPrintQueueRequest"> & {
  /**
   * @generated from field: string printer_id = 1;
   */
  printerId: string;
};

/**
 * Describes the message sidecar.v1.GetPrintQueueRequest.
 * Use `create(GetPrintQueueRequestSchema)` to create a new message.
 */
export const GetPrintQueueRequestSchema: GenMessage<GetPrintQueueRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 6);

/**
 * @generated from message sidecar.v1.GetPrintQueueResponse
 */
export type GetPrintQueueResponse = Message<"sidecar.v1.GetPrintQueueResponse"> & {
  /**
   * @generated from field: repeated sidecar.v1.PrintJobInfo jobs = 1;
   */
  jobs: PrintJobInfo[];
};

/**
 * Describes the message sidecar.v1.GetPrintQueueResponse.
 * Use `create(GetPrintQueueResponseSchema)` to create a new message.
 */
export const GetPrintQueueResponseSchema: GenMessage<GetPrintQueueResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 7);

/**
 * @generated from message sidecar.v1.SubscribePrintQueueRequest
 */
export type SubscribePrintQueueRequest = Message<"sidecar.v1.SubscribePrintQueueRequest"> & {
  /**
   * @generated from field: string printer_id = 1;
   */
  printerId: string;
};

/**
 * Describes the message sidecar.v1.SubscribePrintQueueRequest.
 * Use `create(SubscribePrintQueueRequestSchema)` to create a new message.
 */
export const SubscribePrintQueueRequestSchema: GenMessage<SubscribePrintQueueRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 8);

/**
 * @generated from message sidecar.v1.SubscribePrintQueueResponse
 */
export type SubscribePrintQueueResponse = Message<"sidecar.v1.SubscribePrintQueueResponse"> & {
  /**
   * @generated from field: repeated sidecar.v1.PrintJobInfo jobs = 1;
   */
  jobs: PrintJobInfo[];
};

/**
 * Describes the message sidecar.v1.SubscribePrintQueueResponse.
 * Use `create(SubscribePrintQueueResponseSchema)` to create a new message.
 */
export const SubscribePrintQueueResponseSchema: GenMessage<SubscribePrintQueueResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 9);

/**
 * @generated from message sidecar.v1.CancelPrintJobRequest
 */
export type CancelPrintJobRequest = Message<"sidecar.v1.CancelPrintJobRequest"> & {
  /**
   * @generated from field: string printer_id = 1;
   */
  printerId: string;

  /**
   * @generated from field: uint32 job_id = 2;
   */
  jobId: number;
};

/**
 * Describes the message sidecar.v1.CancelPrintJobRequest.
 * Use `create(CancelPrintJobRequestSchema)` to create a new message.
 */
export const CancelPrintJobRequestSchema: GenMessage<CancelPrintJobRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 10);

/**
 * @generated from message sidecar.v1.CancelPrintJobResponse
 */
export type CancelPrintJobResponse = Message<"sidecar.v1.CancelPrintJobResponse"> & {
};

/**
 * Describes the message sidecar.v1.CancelPrintJobResponse.
 * Use `create(CancelPrintJobResponseSchema)` to create a new message.
 */
export const CancelPrintJobResponseSchema: GenMessage<CancelPrintJobResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 11);

/**
 * @generated from message sidecar.v1.PrintTestPageRequest
 */
export type PrintTestPageRequest = Message<"sidecar.v1.PrintTestPageRequest"> & {
  /**
   * @generated from field: string printer_id = 1;
   */
  printerId: string;

  /**
   * @generated from field: string printer_type = 2;
   */
  printerType: string;

  /**
   * @generated from field: string page_size = 3;
   */
  pageSize: string;

  /**
   * @generated from field: string roll_width = 4;
   */
  rollWidth: string;
};

/**
 * Describes the message sidecar.v1.PrintTestPageRequest.
 * Use `create(PrintTestPageRequestSchema)` to create a new message.
 */
export const PrintTestPageRequestSchema: GenMessage<PrintTestPageRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 12);

/**
 * @generated from message sidecar.v1.PrintTestPageResponse
 */
export type PrintTestPageResponse = Message<"sidecar.v1.PrintTestPageResponse"> & {
};

/**
 * Describes the message sidecar.v1.PrintTestPageResponse.
 * Use `create(PrintTestPageResponseSchema)` to create a new message.
 */
export const PrintTestPageResponseSchema: GenMessage<PrintTestPageResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 13);

/**
 * @generated from message sidecar.v1.PrintDocumentRequest
 */
export type PrintDocumentRequest = Message<"sidecar.v1.PrintDocumentRequest"> & {
  /**
   * @generated from field: string printer_id = 1;
   */
  printerId: string;

  /**
   * @generated from field: string document_name = 2;
   */
  documentName: string;

  /**
   * @generated from field: bytes pdf_data = 3;
   */
  pdfData: Uint8Array;
};

/**
 * Describes the message sidecar.v1.PrintDocumentRequest.
 * Use `create(PrintDocumentRequestSchema)` to create a new message.
 */
export const PrintDocumentRequestSchema: GenMessage<PrintDocumentRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 14);

/**
 * @generated from message sidecar.v1.PrintDocumentResponse
 */
export type PrintDocumentResponse = Message<"sidecar.v1.PrintDocumentResponse"> & {
};

/**
 * Describes the message sidecar.v1.PrintDocumentResponse.
 * Use `create(PrintDocumentResponseSchema)` to create a new message.
 */
export const PrintDocumentResponseSchema: GenMessage<PrintDocumentResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 15);

/**
 * @generated from message sidecar.v1.ReceiptTextLine
 */
export type ReceiptTextLine = Message<"sidecar.v1.ReceiptTextLine"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: bool bold = 2;
   */
  bold: boolean;

  /**
   * @generated from field: bool underline = 3;
   */
  underline: boolean;

  /**
   * @generated from field: uint32 font_size = 4;
   */
  fontSize: number;

  /**
   * @generated from field: string alignment = 5;
   */
  alignment: string;
};

/**
 * Describes the message sidecar.v1.ReceiptTextLine.
 * Use `create(ReceiptTextLineSchema)` to create a new message.
 */
export const ReceiptTextLineSchema: GenMessage<ReceiptTextLine> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 16);

/**
 * @generated from message sidecar.v1.ReceiptSection
 */
export type ReceiptSection = Message<"sidecar.v1.ReceiptSection"> & {
  /**
   * @generated from oneof sidecar.v1.ReceiptSection.content
   */
  content: {
    /**
     * @generated from field: bytes image_data = 1;
     */
    value: Uint8Array;
    case: "imageData";
  } | {
    /**
     * @generated from field: string text = 2;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: sidecar.v1.ReceiptTextLine styled_text = 3;
     */
    value: ReceiptTextLine;
    case: "styledText";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message sidecar.v1.ReceiptSection.
 * Use `create(ReceiptSectionSchema)` to create a new message.
 */
export const ReceiptSectionSchema: GenMessage<ReceiptSection> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 17);

/**
 * @generated from message sidecar.v1.PrintReceiptRequest
 */
export type PrintReceiptRequest = Message<"sidecar.v1.PrintReceiptRequest"> & {
  /**
   * @generated from field: string printer_id = 1;
   */
  printerId: string;

  /**
   * @generated from field: string document_name = 2;
   */
  documentName: string;

  /**
   * @generated from field: repeated sidecar.v1.ReceiptSection header = 3;
   */
  header: ReceiptSection[];

  /**
   * @generated from field: repeated sidecar.v1.ReceiptSection body = 4;
   */
  body: ReceiptSection[];

  /**
   * @generated from field: repeated sidecar.v1.ReceiptSection footer = 5;
   */
  footer: ReceiptSection[];

  /**
   * @generated from field: bool cut_after = 6;
   */
  cutAfter: boolean;
};

/**
 * Describes the message sidecar.v1.PrintReceiptRequest.
 * Use `create(PrintReceiptRequestSchema)` to create a new message.
 */
export const PrintReceiptRequestSchema: GenMessage<PrintReceiptRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 18);

/**
 * @generated from message sidecar.v1.PrintReceiptResponse
 */
export type PrintReceiptResponse = Message<"sidecar.v1.PrintReceiptResponse"> & {
};

/**
 * Describes the message sidecar.v1.PrintReceiptResponse.
 * Use `create(PrintReceiptResponseSchema)` to create a new message.
 */
export const PrintReceiptResponseSchema: GenMessage<PrintReceiptResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_printer_local_api, 19);

/**
 * @generated from service sidecar.v1.PrinterLocalService
 */
export const PrinterLocalService: GenService<{
  /**
   * @generated from rpc sidecar.v1.PrinterLocalService.ListPrinters
   */
  listPrinters: {
    methodKind: "unary";
    input: typeof ListPrintersRequestSchema;
    output: typeof ListPrintersResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.PrinterLocalService.GetPrinterInfo
   */
  getPrinterInfo: {
    methodKind: "unary";
    input: typeof GetPrinterInfoRequestSchema;
    output: typeof GetPrinterInfoResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.PrinterLocalService.GetPrintQueue
   */
  getPrintQueue: {
    methodKind: "unary";
    input: typeof GetPrintQueueRequestSchema;
    output: typeof GetPrintQueueResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.PrinterLocalService.SubscribePrintQueue
   */
  subscribePrintQueue: {
    methodKind: "server_streaming";
    input: typeof SubscribePrintQueueRequestSchema;
    output: typeof SubscribePrintQueueResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.PrinterLocalService.CancelPrintJob
   */
  cancelPrintJob: {
    methodKind: "unary";
    input: typeof CancelPrintJobRequestSchema;
    output: typeof CancelPrintJobResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.PrinterLocalService.PrintTestPage
   */
  printTestPage: {
    methodKind: "unary";
    input: typeof PrintTestPageRequestSchema;
    output: typeof PrintTestPageResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.PrinterLocalService.PrintDocument
   */
  printDocument: {
    methodKind: "unary";
    input: typeof PrintDocumentRequestSchema;
    output: typeof PrintDocumentResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.PrinterLocalService.PrintReceipt
   */
  printReceipt: {
    methodKind: "unary";
    input: typeof PrintReceiptRequestSchema;
    output: typeof PrintReceiptResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_sidecar_v1_printer_local_api, 0);

